import React from 'react'
import { DisablePage } from '../DisablePage'
import salesforce from '../../images/salesforce.svg'
import hubspot from '../../images/hubspot.svg'
import connectwise from '../../images/connectwise.svg'
import dynamics from '../../images/dynamics.svg'

export const CRMBlockPage = () => {
  const productInfo = {
    title: "Your plan dosen't include CRM integration",
    features: [
      {
        text: 'Easily list your software products and services on the AWS marketplace',
      },
      {
        text: 'Create private offers (CPPO)',
      },
      {
        text: 'Manage revenue tracking all from your own CRM',
      },
    ],
    buttonText: 'Request to enable',
    status: 'Coming soon',
    statusIndex: 3,
    subheading:
      'Please purchase the Labra Co-pilot App to do the following all from your CRM',
    products: [salesforce, hubspot, connectwise, dynamics],
  }
  return (
    <div>
      <DisablePage productInfo={productInfo} header={'Crm settings '} />
    </div>
  )
}
